import { adminAuthenticationImpersonateStopGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminAuthenticationImpersonateStopReducers = combineReducers({
	get: adminAuthenticationImpersonateStopGetSlice.asyncReducers
});

export const adminAuthenticationImpersonateStopWatchers = combineAllWatchers([
	adminAuthenticationImpersonateStopGetSlice.asyncWatchers
]);
